import axios from "axios";
import { API_key, Base_URL } from "src/apiConstants";

/*............................PagesFunctions..................................*/
export const getMoviesList = (type: string, page: string) =>
  axios.get(`${Base_URL}/movie/${type}?${API_key}&language=en-US&page=${page}`);

export const getTVShowsList = (type: string, page: string) =>
  axios.get(`${Base_URL}/tv/${type}?${API_key}&language=en-US&page=${page}`);

export const getPopularPeopleList = (type: string, page: string) =>
  axios.get(
    `${Base_URL}/person/${type}?${API_key}&language=en-US&page=${page}`,
  );

/*............................DetailedPagesFunctions..........................*/
export const getMovieDetail = (moveId: string | undefined) => {
  return axios.get(`${Base_URL}/movie/${moveId}?${API_key}&language=en-US`);
};
export const getShowDetail = (showId: string | undefined) => {
  return axios.get(`${Base_URL}/tv/${showId}?${API_key}&language=en-US`);
};
export const getPersonDetail = (personId: string | undefined) => {
  return axios.get(`${Base_URL}/person/${personId}?${API_key}&language=en-US`);
};
